import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 50px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const ImageDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 2;
  gap: 30px;
  width: 100%;
`;

export const TagContainer = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 10px;
  min-height: 20px;
  flex-wrap: wrap;
`;
